module.exports = __webpack_public_path__ + "img/icon19.9c332cd0.png";